import { forkJoin, Observable, of } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { inject, injectable } from "tsyringe";
import { PgaPolicy, VehiclePolicy } from "src/shared/models";
import { VehiclesService } from "src/containers/vehicles/services/vehicles/vehicles-service";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class PlanKilometersRepository {
    constructor(@inject("VehiclesService") private service: VehiclesService) {}

    @autoBind
    getTracking(
        policy: PgaPolicy,
        userIdentity: string
    ): Observable<VehiclePolicy> {
        return this.service
            .getTracking(userIdentity, policy.product.systemCode, policy.id)
            .pipe(
                map((tracking) => {
                    return VehiclePolicy.fromJson<VehiclePolicy>({
                        ...policy,
                        tracking,
                    });
                })
            );
    }

    @autoBind
    getPoliciesWithTracking(
        policies: PgaPolicy[],
        userIdentity?: string
    ): Observable<VehiclePolicy[]> {
        const trackings$: Array<Observable<VehiclePolicy>> = [];
        for (const policy of policies) {
            const obs$ = of(policy).pipe(
                mergeMap(() => {
                    return this.service
                        .getTracking(
                            userIdentity ?? window.userIdentity,
                            policy.product.systemCode,
                            policy.id
                        )
                        .pipe(
                            mergeMap((tracking) => {
                                return of(
                                    VehiclePolicy.fromJson<VehiclePolicy>({
                                        ...policy,
                                        tracking: tracking,
                                    })
                                );
                            })
                        );
                })
            );
            trackings$.push(obs$);
        }
        return forkJoin(trackings$);
    }
}
